import { render, staticRenderFns } from "./DeviceDeleteRecord.vue?vue&type=template&id=39a90e26&scoped=true&"
import script from "./DeviceDeleteRecord.vue?vue&type=script&lang=js&"
export * from "./DeviceDeleteRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a90e26",
  null
  
)

export default component.exports